// import $ from "jquery";
import breadcrumb from './breadcrumb';
import content from './content';
import "../../../node_modules/@prokomssp/fantdu/dist/fantdu.min.js";




export default function(client) {

    const breadcrumbHtml = breadcrumb();
    document.title = "Nyheter";

    let nameId = client.nameId || "";

    // console.log("[in article: before content]");
    content(client.clientId, client.servioId);

    // console.log("[in article: after content]");


    window.fantdu__success = function(result) {

        let traces = [];

        result.trace.$values.forEach(data => {

            let time = data.timeOut / 1000;



            traces.push(`
                <li>${time} sek, <a href="${decodeURIComponent(data.pageUrl)}">${decodeURIComponent(data.pageName)}</a></li>
           `)

            //   console.log("traces", `
            //         <li>${time} sek, <a href="${decodeURIComponent(data.pageUrl)}">${data.pageName}</a></li>
            //   `);

        });

        let comment = ``;

        // console.log(result.comment, result.comment.length, comment)

        if (result.comment.length > 0) {
            console.log("comment inside", result.comment);
            comment = `${result.comment}`;
        }


        // console.log("result - fantdu : ", result)

        traces = traces.join("");

        let fantdu__comment = `<span class="badge badge-${(result.isPositive ? "success\">Positiv" : "danger\">Negativ")}</span>
            <br/>
            ${comment}
            <br/><br/>
            <h6>Sporing:</h6>
            <ol>
            ${traces}
            </ol>
        `;



        let data = {
            "taskFinished": false,
            "taskDescription": fantdu__comment,
            "title": `Fantdu (${(result.isPositive ? "Positiv" : "Negativ")}) ${comment.length < 1 ? "Ingen kommentar" : comment.substr(0,20)+"..."}`,
            "subscriptionId": contentSubscription,
            "contentId": contentID,
            "taskState": 0,
            "taskType": "FantDu"
        };

        // console.log("data fantdu: ", data);

        let senddata = JSON.stringify(data);

        // console.log("sendata fantdu ok", senddata);


        // Get JSON 
        $.ajax({
            type: "POST",
            url: window.apiUrl + "/api/UserTaskApi/create",
            contentType: "application/json-patch+json",
            data: senddata,
            headers: { "subscriptionId": client.clientId }
        }).done(function(alle) {

        });


    }

    window.fandu__failed = function(result) {

        let traces = [];

        result.trace.$values.forEach(data => {

            let time = data.timeOut / 1000;

            traces.push(`
                <li>${time} sek, <a href="${data.pageUrl}">${data.pageName}</a></li>
           `)

        });

        let comment = ``;

        if (result.comment.length > 0) {
            comment = `${result.comment}`;
        }
        // console.log("result - fantdu : ", result)

        traces = traces.join("");

        let fantdu__comment = `
            Fantdu feilet, returnerer res etter stat:<br>
            <span class="badge badge-${(result.isPositive ? "success\">Positiv" : "danger\">Negativ")}</span>
            <br/>
            ${comment}
            <br/><br/>
            <h6>Sporing:</h6>
            <ol>
            ${traces}
            </ol>
        `;



        let data = {
            "taskFinished": false,
            "taskDescription": fantdu__comment,
            "title": `Fantdu (${(result.isPositive ? "Positiv" : "Negativ")}) ${comment.length < 1 ? "Ingen kommentar" : comment.substr(0,20)+"..."}`,
            "subscriptionId": contentSubscription,
            "contentId": contentID,
            "taskState": 0,
            "taskType": "FantDu"
        };

        let senddata = JSON.stringify(data);

        // console.log("sendata fantdu error", senddata);

        // Get JSON
        $.ajax({
            type: "POST",
            url: window.apiUrl + "/api/UserTaskApi/create",
            contentType: "application/json-patch+json",
            data: senddata,
        }).done(function(alle) {

        });


    }


    return `
    
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container p-md-0" id="contentHtml">
        
                <div class="row">
                    <div class="col-sm-12 text-center">
                    
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                                          
                    </div>
                </div>
        
        </div>
        <div class="fant_du_container">
            <fant-du client="${nameId}" onSubmitSuccess="fantdu__success" onSubmitFail="fandu__failed" css="
                button.fant-du__button {
                    border-color: var(--fantdu__border__color, var(--primary__color));border-radius:0;
                }
                textarea.fant-du__textarea {
                    background-color: #ffffff;
                }
                "></fant-du> 
        </div>
    `;

}
